export default `
  mutation restoreOrganisation($id: String!) {
    restoreOrganisation(id: $id) {
        id
        name
        userId
        deletedAt
        updatedAt
      }
  }
`
